const isMobile = () => window.matchMedia('(max-width: 600px)').matches;
export default isMobile;